export default function getHighestRole(userRoles) {
  if (!userRoles.length > 0) return "member";
  let highestRole = "member";
  for (let i = 0; i < userRoles.length; i += 1) {
    if (userRoles[i] === "admin") return "admin";
    if (userRoles[i] === "host") highestRole = "host";
  }
  return highestRole;
}
